"use client";
import React, { useRef, useState } from "react";
import { useSwipeable } from "react-swipeable";

import { SWIPEABLE_CONFIG } from "@/shared/constants/common";
import { useClickOutside } from "@/shared/hooks/common";
import { SelectableTheme } from "@/shared/types/theme";

import * as S from "./styled";
interface Props {
  onThemeChange: (theme: SelectableTheme) => void;
  selectableTheme: SelectableTheme;
}

export const ThemeButton: React.FC<Props> = ({
  onThemeChange,
  selectableTheme,
}) => {
  const [isModalOpen, setModalOpenStatus] = useState(false);
  const ref = useRef(null);

  useClickOutside(ref, () => setModalOpenStatus(false));

  const handleThemeClick = (theme: SelectableTheme) => {
    onThemeChange(theme);
    setModalOpenStatus(false);
  };

  const handlers = useSwipeable({
    onSwipedDown: () => setModalOpenStatus(false),
    ...SWIPEABLE_CONFIG,
  });

  return (
    <>
      {isModalOpen && (
        <S.ModalWrapper {...handlers}>
          <S.ModalBody
            ref={ref}
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
            }}
          >
            <S.ThemeModalHeading>Choose appearance</S.ThemeModalHeading>

            <S.ThemeSelect
              onClick={() => {
                handleThemeClick("auto");
              }}
            >
              Auto
              {selectableTheme === "auto" && (
                <img src="/images/check.svg" alt="" />
              )}
            </S.ThemeSelect>

            <S.ThemeSelect
              onClick={() => {
                handleThemeClick("dark");
              }}
            >
              Dark
              {selectableTheme === "dark" && (
                <img src="/images/check.svg" alt="" />
              )}
            </S.ThemeSelect>

            <S.ThemeSelect
              onClick={() => {
                handleThemeClick("light");
              }}
            >
              Light
              {selectableTheme === "light" && (
                <img src="/images/check.svg" alt="" />
              )}
            </S.ThemeSelect>
          </S.ModalBody>
        </S.ModalWrapper>
      )}
      <S.Wrapper
        onClick={() => {
          setModalOpenStatus(true);
        }}
      >
        <img src="/images/moon.svg" alt="" />
      </S.Wrapper>
    </>
  );
};
